// useNavigationTree.js
import { useState, useEffect } from "react";
import { fetchApi } from "@/utils/fetchApi";
import * as Icons from "react-feather";
import useAuth from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

function updateIcons(items) {
  return items.map((item) => {
    const updatedItem = { ...item };

    // Update the icon, if it exists in the Icons object
    if (updatedItem.icon && Icons[updatedItem.icon]) {
      updatedItem.icon = Icons[updatedItem.icon];
    }

    // Recursively update children, if they exist
    if (updatedItem.children && updatedItem.children.length > 0) {
      updatedItem.children = updateIcons(updatedItem.children);
    }

    return updatedItem;
  });
}

const useNavigationTree = (navigationgroupid, roleid) => {
  const [navItems, setNavItems] = useState([]);
  const { authToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApplicationTree = async () => {
      try {
        const response = await fetchApi("navigations", "getApplicationTree", {
          navigationgroupid: navigationgroupid,
          accesstoken: authToken.AccessToken,
        });

        if (response.tree.length === 0) {
          navigate("/auth/sign-in");
          return;
        }
        setNavItems([
          {
            title: "OnRounds AI",
            pages: updateIcons(response.tree),
          },
        ]);
      } catch (error) {
        console.error("Error fetching application tree", error);
        navigate("/auth/sign-in");
      }
    };

    if (authToken?.AccessToken) fetchApplicationTree();
  }, [navigationgroupid, roleid, authToken, navigate]);

  return navItems;
};

export default useNavigationTree;
